
import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faEye, faEyeSlash);

@Component({
  inheritAttrs: false,
  components: {
    FontAwesomeIcon,
  },
})
export default class PasswordInput extends Vue {
  @Prop({ required: true }) value!: string;
  @Prop({ default: '' }) name!: string;
  @Prop({ default: '' }) inputClass!: string;
  @Prop({ default: null }) tabindex!: number | null;
  @Prop({ default: 'current-password' }) autocomplete!: string;
  @Prop({ default: null }) size!: number | null;
  @Prop({ default: false }) required!: boolean;

  T = T;
  showPassword = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
